<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-app id="cheerfulgive-scanQrcode">
    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-main>
      <v-container>
        <!-- 上方左右側按鈕 -->
        <v-row>
          <div class="d-flex justify-space-between text-h6 white--text" style="z-index:100;">
              <v-btn
                  icon
                  @click="back"
                  dark
                  x-large
                  elevation="2"
                  class="mt-3 ml-3 mt-sm-5 ml-sm-5"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
          <div class="qrcode-stream-block">
            <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit" style="width:100vw; height:100vw;">
              <div v-if="validationPending" class="validation-pending">
                {{ $t('confirming') }}...
              </div>
            </qrcode-stream>
            <div>
              <img src="@/assets/images/qr-camera.png" alt="qr-camera" style="width:100vw; height:100vw; position:absolute; top:0;">
            </div>
            <v-row justify="center" class="freekey-btn-block">
              <div>
                <v-btn rounded
                  dark elevation="2" class="text-xs-h5 text-sm-h5 font-weight-bold freekey-btn-v-btn" @click="freeKeySheet = true">
                  <bx-text class="cheerfulgive-icon freekey-btn-icon" />
                  {{ $t('keyIn') }}
                </v-btn>
              </div>
            </v-row>
            <v-row justify="center" class="bottom-block">
              <div>
                <div class="py-3">
                  <span class="ac-scan-qrcode text-xs-h5 text-sm-h5 font-weight-medium">{{ $t('acScanQrCode') }}</span>
                </div>
                <div class="pt-3">
                  <p class="mb-2 font-weight-bold text-xs-h5 text-sm-h5">{{ $t('activityTitle') }}：{{activityTitle}}</p>
                  <p class="mb-2 font-weight-bold text-xs-h5 text-sm-h5">{{ $t('sessionTitle') }}：{{sessionTitle}}</p>
                  <p class="mb-2 font-weight-bold text-xs-h5 text-sm-h5">{{ $t('lessonTitle') }}：{{lessonTitle}}</p>
                </div>
                <div class="mt-xs-1 mt-2">
                  <img src="@/assets/images/cheerfulgive-logo.png" alt="cheerfulgive-logo" class="logo-img">
                </div>
                <v-btn color="blue" elevation="2" outlined class="text-xs-h6 text-sm-h6 mt-4 mt-sm-7" :ripple="false" @click="goReport">
                  {{ $t('checkInRecord') }}
                </v-btn>
              </div>
            </v-row>
          </div>
        </v-row>

        <!-- 手動輸入 -->
        <v-bottom-sheet
          v-model="freeKeySheet"
          persistent
        >
          <v-overlay :value="isLoading">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
          <v-sheet
            class="text-center"
            height=""
            style="padding:20px;"
          >
            <v-row justify="end">
              <v-btn class="mx-5"
                icon
                @click="freeKeySheet = false;ticketNumber = null"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-row>
            <v-row justify="center">
              <v-col>
                <p style="text-align:start; margin:0 0 10px 10px;">票卷編號</p>
                <v-text-field
                v-model="ticketNumber"
                placeholder="請輸入票卷編號"
                outlined
                style="display:inline-flex; text-align:start; width:70%; margin-right:20px;"
                ></v-text-field>
                <v-btn
                  elevation="2"
                  @click="freekeyOk()"
                  style="background: #FEAA3C; color:#fff;"
                >確認</v-btn>
              </v-col>
            </v-row>
            <div>
              <div class="py-3">
                <span class="ac-scan-qrcode text-xs-h5 text-sm-h5 font-weight-medium">{{ $t('acScanQrCode') }}</span>
              </div>
              <div class="pt-3">
                <p class="mb-2 font-weight-bold text-xs-h5 text-sm-h5">{{ $t('activityTitle') }}：{{activityTitle}}</p>
                <p class="mb-2 font-weight-bold text-xs-h5 text-sm-h5">{{ $t('sessionTitle') }}：{{sessionTitle}}</p>
                <p class="mb-2 font-weight-bold text-xs-h5 text-sm-h5">{{ $t('lessonTitle') }}：{{lessonTitle}}</p>
              </div>
              <div class="mt-xs-1 mt-2">
                <img src="@/assets/images/cheerfulgive-logo.png" alt="cheerfulgive-logo" class="logo-img">
              </div>
              <v-btn color="blue" elevation="2" outlined class="text-xs-h6 text-sm-h6 mt-4 mt-sm-7" :ripple="false" @click="goReport">
                {{ $t('checkInRecord') }}
              </v-btn>
            </div>
            <!-- <div class="py-3">
              <span class="title">現場報到掃碼</span>
            </div>
            <div class="py-3">
              活動名稱：{{activityTitle}}<br/>
              場次名稱：{{sessionTitle}}<br/>
              課堂名稱：{{lessonTitle}}
            </div>
            <img src="@/assets/images/cheerfulgive-logo.png" alt="cheerfulgive-logo" class="logo-img">
            <br/>
            <br/>
            <v-btn color="blue" elevation="2" outlined class="text-h6" :ripple="false" @click="goReport">
            {{ $t('checkInRecord') }}
            </v-btn> -->
          </v-sheet>
        </v-bottom-sheet>
      </v-container>
    </v-main>
    <v-snackbar
      v-model="formTip"
      multi-line
      top
      color="error">
      {{ formTipText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="formTip = false">
          <icon-close class="cheerfulgive-icon" />
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar
      v-model="success"
      multi-line
      top
      color="success">
      {{ $t(successContent) }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="success = false">
          <icon-close class="cheerfulgive-icon" />
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
      v-model="actualDialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 success">
          實際報到人數
        </v-card-title>

        <v-card-text class="py-5">
          <div>
            <vue-number-input v-model="actualPeople" :min="1" inline center controls></vue-number-input>
          </div>
          <div>
          預計人數：{{estimatePeople}}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            text
            @click="editActual"
          >
            確認
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import API from '@/apis'
import IconClose from '@/assets/icons/close.vue'
import VueNumberInput from '@chenfengyuan/vue-number-input'
import BxText from '@/assets/icons/bx-text.vue'

export default {
  components: {
    QrcodeStream,
    IconClose,
    VueNumberInput,
    BxText
  },
  data () {
    return {
      lessonId: '',
      formTipText: '',
      formTip: false,
      isValid: undefined,
      camera: 'auto',
      result: null,
      sheet: false,
      activityTitle: '',
      sessionTitle: '',
      lessonTitle: '',
      success: false,
      successContent: '',
      actualDialog: false,
      freeKeySheet: false,
      ticketNumber: null,
      ticketData: null,
      estimatePeople: 1,
      actualPeople: null,
      isLoading: false
    }
  },
  computed: {
    validationPending () {
      return this.isValid === undefined &&
        this.camera === 'off'
    }
  },
  created () {
    const params = new URLSearchParams(window.location.search)
    this.lessonId = params.get('id')
    this.isLoading = true
    API.activity.getLessonInfo(this.lessonId).then(res => {
      if (res.data.success) {
        this.activityTitle = res.data.activityTitle
        this.sessionTitle = res.data.sessionTitle
        this.lessonTitle = res.data.lessonTitle
      } else {
        this.formTipText = this.$t(`${res.data.message}`)
        this.formTip = true
        this.back()
      }
      this.isLoading = false
    })
  },
  methods: {
    back () {
      this.$router.push('/activity')
    },
    goReport () {
      this.$router.push(`/checkInRecord?id=${this.lessonId}`)
    },
    onInit (promise) {
      promise
        .catch(console.error)
        .then(this.resetValidationState)
    },

    resetValidationState () {
      this.isValid = undefined
    },

    async onDecode (content) {
      this.result = content
      if (this.isLoading) {
        return
      }
      this.turnCameraOff()
      // pretend it's taking really long
      this.isValid = this.result.startsWith('http')
      const ticketUrl = new URL(this.result)
      const ticketData = ticketUrl.searchParams
      this.ticketData = ticketData.get('data')
      // some more delay, so users have time to read the message
      this.checkIn()
    },
    checkIn () {
      const params = {
        ticketData: this.ticketData,
        ticketNumber: this.ticketNumber,
        actualPeople: this.actualPeople,
        lessonId: this.lessonId
      }
      this.isLoading = true
      return API.activity.checkIn(params).then(res => {
        const data = res.data
        if (data.success) {
          if (data.isCheckinOnsite) {
            this.actualDialog = true
            this.estimatePeople = data.estimatePeople
            this.actualPeople = data.estimatePeople
          } else {
            this.successContent = data.message
            this.success = true
            this.freeKeySheet = false
            this.actualDialog = false
            this.defultParams()
          }
        } else {
          this.formTipText = this.$t(`${data.message}`)
          this.formTip = true
          this.defultParams()
        }
        this.turnCameraOn()
        this.isLoading = false
        return data
      })
    },
    defultParams () {
      this.ticketData = null
      this.ticketNumber = null
      this.actualPeople = null
    },
    editActual () {
      if (this.isLoading) {
        return
      }
      this.checkIn()
    },
    async freekeyOk () {
      if (this.isLoading) {
        return
      }
      if (this.ticketNumber == null || this.ticketNumber.length < 3) {
        this.formTipText = this.$t('請輸入完整編號')
        this.formTip = true
        return
      }
      this.checkIn()
    },
    turnCameraOn () {
      this.camera = 'auto'
    },

    turnCameraOff () {
      this.camera = 'off'
    },

    timeout (ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-application .elevation-2 {
  box-shadow: none !important;
}

#cheerfulgive-scanQrcode {

  .ac-scan-qrcode {
    color:#FEAA3C;
    letter-spacing: 1px;
    padding-bottom: 4px;
    border-bottom: #FEAA3C 1px solid;
  }

  .freekey-btn-block {
    margin-top: -10%;

    .freekey-btn-v-btn {
      color: #fff;
      background-color: rgba(0, 0, 0, 0.5);;
      }
  }

  .bottom-block {
    margin-top: 5vh;
    padding: 20px;
    background-color:white;
    height: 40vh;
    text-align: center;
  }

  .logo-img {
    width: 80%;
    margin-top: 10px !important;
  }

  .qrcode-stream-block {
    position: absolute;
    top: 0;
    z-index: 2;
  }
}

@media screen and (max-width:767px) {
  .logo-img {
    width: 90%;
    margin-top: 10px !important;
  }

  .freekey-btn-block {
    margin-top: -15% !important;
  }
}
</style>
